<template>
  <div class="h-full bg-white z-20 sm:inline-block shrink-0" :class="{ 
    'absolute w-full ': takeAll, 
    'relative': !takeAll, 
    '!w-64 inline-block': !takeAll && expanded, 
    'w-16 hidden': !expanded }">
    <div class="relative h-20 text-center p-2 inline-block w-full">
      <img v-if="!expanded" src="@/assets/favicon.png" class="max-w-full max-h-full inline-block"/>
      <img v-else src="@/assets/logo.png" class="max-w-full max-h-full inline-block"/>
    </div>

    <div :class="expanded ? 'px-4' : 'text-center'">
      <div v-if="expanded" class="w-full text-right ">
        <font-awesome-icon icon="arrow-left" class="text-3xl text-primary cursor-pointer" @click="expanded = false; takeAll = false" />
      </div>
      <font-awesome-icon v-else icon="bars" class="text-3xl text-primary cursor-pointer" @click="expanded = true" />
      <div class="w-full">
        <router-link to="/" class="inline-block border-b-4 text-3xl  hover:border-primarylight cursor-pointer pt-3" :class="title === 'Home' ? 'border-primary' : 'border-white'" @click="afterNav()">
          <font-awesome-icon icon="home" class="w-8" :class="title === 'Home' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-2 text-lg font-bold">{{ $t('Home') }}</span>
        </router-link>
      </div>
      
      <div v-if="user.subaccount == false" class="w-full" >
        <router-link to="/mydata" class="inline-block border-b-4 text-3xl  hover:border-primarylight cursor-pointer pt-3" :class="title === 'Meine Daten' ? 'border-primary' : 'border-white'" @click="afterNav()">
          <font-awesome-icon icon="address-card" class="w-8" :class="title === 'Meine Daten' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-2 text-lg font-bold">{{ $t('Meine Daten') }}</span>
        </router-link>
      </div>
      <div v-if="user.subaccount == false && user.anyContract" class="w-full" >
        <router-link to="/services" class="inline-block border-b-4 text-3xl  hover:border-primarylight cursor-pointer pt-3" :class="title === 'Meine Leistungen' ? 'border-primary' : 'border-white'" @click="afterNav()">
          <font-awesome-icon icon="file-contract" class="w-8" :class="title === 'Meine Leistungen' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-2 text-lg font-bold">{{ $t('Meine Leistungen') }}</span>
        </router-link>
      </div>
      <div v-if="!user.user || user.subaccount == false"  class="w-full" >
        <router-link to="/book" class="inline-block border-b-4 text-3xl  hover:border-primarylight cursor-pointer pt-3" :class="title === 'Leistung buchen' ? 'border-primary' : 'border-white'" @click="afterNav()">
          <font-awesome-icon icon="cart-shopping" class="w-8" :class="title === 'Leistung buchen' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-2 text-lg font-bold">{{ $t('Leistung buchen') }}</span>
        </router-link>
      </div>
      <div v-if="user.mealplan" class="w-full">
        <router-link to="/cards" class="inline-block border-b-4 text-3xl  hover:border-primarylight cursor-pointer pt-3" :class="title === 'Mensakarten' ? 'border-primary' : 'border-white'" @click="afterNav()">
          <font-awesome-icon icon="credit-card" class="w-8" :class="title === 'Mensakarten' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-2 text-lg font-bold">{{ $t('Mensakarten') }}</span>
        </router-link>
      </div>
      <div v-if="user.mealplan" class="w-full">
        <router-link to="/mealplanning" class="inline-block border-b-4 text-3xl  hover:border-primarylight cursor-pointer pt-3" :class="title === 'Essensplanung' ? 'border-primary' : 'border-white'" @click="afterNav()">
          <font-awesome-icon icon="utensils" class="w-8" :class="title === 'Essensplanung' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-2 text-lg font-bold">{{ $t('Essensplanung') }}</span>
        </router-link>
      </div>
      <div v-if="user.subaccount == false && user.pickup" class="w-full">
        <router-link to="/pickup" class="inline-block border-b-4 text-3xl  hover:border-primarylight cursor-pointer pt-3" :class="title === 'Abholung' ? 'border-primary' : 'border-white'" @click="afterNav()">
          <font-awesome-icon icon="person-walking-dashed-line-arrow-right" class="w-8" :class="title === 'Abholung' ? 'text-primary' : 'text-black'" />
          <span v-if="expanded" class="ml-2 text-lg font-bold">{{ $t('Abholung') }}</span>
        </router-link>
      </div>
    </div>

    <div class="absolute left-0 bottom-0 w-full text-center">
      <a v-if="user.hasRealAccount" :href="`${backend}/changepw`">
        <button v-if="expanded" class="full">{{ $t('Passwort ändern') }}</button>
        <font-awesome-icon v-else class="text-3xl text-red-300 cursor-pointer mb-2" icon="key" />
      </a>
      <div class="mt-2" >
        <div v-if="expanded && user.user" >
          <button class="full" @click="logout">{{ $t('Abmelden') }}</button><br>
        </div>
        <button v-else-if="expanded" class="full" @click="window.location.href = '/login'">{{ $t('Anmelden') }}</button>
        <font-awesome-icon v-else-if="!expanded && user.user" class="text-3xl text-red-300 cursor-pointer" @click="logout" icon="right-from-bracket" />
        <font-awesome-icon v-else-if="!expanded" class="text-3xl text-red-300 cursor-pointer" icon="user" @click="window.location.href = '/login'"/>
      </div>
      <div v-if="expanded" class="text-center">
        <router-link v-if="user.user" to="/account" class="underline text-red-500 font-bold text-sm mt-4 inline-block">{{ $t('Account löschen') }}</router-link><br>
        <a href="https://www.ev-angel-isch.de/impressum-2/" class="text-sm mx-3 underline cursor-pointer text-gray-500 font-bold" target="_blank" rel="noopener">{{ $t('Impressum') }}</a>
        <a href="https://www.ev-angel-isch.de/datenschutz/" class="text-sm mx-3 underline cursor-pointer text-gray-500 font-bold" target="_blank" rel="noopener">{{ $t('Datenschutz') }}</a>
      </div>
      <div v-if="expanded" class="text-xs text-gray-400 font-semibold mt-1 mb-2">
        Version {{ version }}
      </div>
    </div>
  </div>
</template>
  
<script>
// @ is an alias to /src
import API from "@/API"
export default {
  name: 'Header',
  props: ['title', 'user'],
  data() {
    return {
      backend: process.env.VUE_APP_EVLINE_URL,
      expanded: true,
      takeAll: false,
      window: window,
      version: process.env.VUE_APP_VERSION,
      largeScreen: window.innerWidth > 1024,
    }
  },
  exposes: ['toggle'],
  methods: {
    afterNav(){
      if(!this.largeScreen){
        this.expanded = false
      }
    },
    toggle(takeAll = false) {
      console.log("toggling")
      this.takeAll = takeAll
      this.expanded = !this.expanded
    },
    logout() {
      API.logout((r, status) => {
        if (status === 200) {
          if(this.user.impersonated){
            window.location=process.env.VUE_APP_EVLINE_URL
          }else{
            window.location = "/login"
          }
        }
      })
    }
  }, created() {
    // dont expand if screen is small
    if (!this.largeScreen) {
      this.expanded = false;
    }
  }
}
</script>
  